import { Component, OnInit } from '@angular/core';
import { DetalleBienCulturalService } from '../../bienes-culturales/detalle-bien-cultural/detalle-bien-cultural.service';
import { DataFichaRegistro, FichaRegistro, FichasRegistroBienesCulturales } from 'app/models/fichaRegistro.model';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ListaBienesComponent } from '../../bienes-culturales/bienes-culturales-list/list/lista-bienes.component';
import { BienesCulturalesService } from '../../bienes-culturales/bienes-culturales-list/bienes-culturales.service';
import { ArrowBackComponent } from "../../../GlobalComponents/arrow-back.component";
import { DataColeccionista } from 'app/models/coleccionitas.model';
import { ColeccionistasService } from '../coleccionistas.service';
import { Router } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { InformacionPersonalColeccionistaComponent } from "./informacion-personal/informacion-personal.component";
import { DpiColeccionistaComponent } from './dpi-coleccionista/dpi-coleccionista.component';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';
import { ActividadRecienteComponent } from 'app/modules/SharedEntitiesComponents/actividad-reciente/actividad-reciente';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'detalle-coleccionista',
    templateUrl: 'detalle-coleccionista.component.html',
    imports: [
    CommonModule,
    MatTabsModule,
    MatButtonModule,
    MatExpansionModule,
    // components
    ListaBienesComponent,
    ArrowBackComponent,
    InformacionPersonalColeccionistaComponent,
    DpiColeccionistaComponent,
    ActividadRecienteComponent
]
})

export class DetalleColeccionistaComponent implements OnInit {

    bienesCulturales$:Observable<FichasRegistroBienesCulturales>
    coleccionista$:Observable<DataColeccionista>
    actividadColeccionista$!: Observable<BitacoraActividadesInterface[]>;

    constructor(
        private bienesService: BienesCulturalesService,
        private coleccionistasService:ColeccionistasService,
        private router: Router,
    ) {

       this.bienesCulturales$= this.bienesService.listBienesCulturales$
       this.coleccionista$= this.coleccionistasService.coleccionista$
       this.actividadColeccionista$ = this.coleccionistasService.bitacoraColeccionista$;
    }

    ngOnInit() { }

    registrarBienCultural(coleccionista: DataColeccionista) {
        if (coleccionista) {
            this.router.navigate(
            [`bienes-culturales/registro/seccion/${coleccionista.coleccionista.seccion.tipologiaId}`],
            {
                queryParams: {
                coleccionista: coleccionista.coleccionista.codigoColeccionista,
                },
                queryParamsHandling: 'merge'
            }
            );
        } else {
            this.router.navigate([`bienes-culturales/registro/seccion/${coleccionista.coleccionista.seccion.tipologiaId}`]);
        }
    }


}